<template>

  <div id="app">

    <ts-nav></ts-nav>

    <div v-show="showShapes" :class="[{about: isAbout}, {works: isWorks}]" id="shape-rect-yellow">
      <svg width="214px" height="214px" viewBox="0 0 214 214">
        <rect width="214" height="214" stroke="#FFE16B" stroke-width="6" stroke-linecap="round" fill="none" stroke-linejoin="round"></rect>
      </svg>
    </div>

    <div v-show="showShapes" :class="[{about: isAbout}, {works: isWorks}]" id="shape-path-blue">
      <svg  width="304px" height="300px" viewBox="0 0 304 300">
        <path stroke-width="3" stroke="#7FF2FF" stroke-linecap="round" stroke-linejoin="round" fill="none" d="M0,300 L304,0"></path>
      </svg>
    </div>

    <transition name="fade-in" appear>
    <div v-show="isHome || isAbout" class="top-gradient container">
      <div class="col offset-sm-5 col-sm-4 offset-md-5 col-md-5 offset-lg-5 col-lg-5"><div></div></div>
    </div>
    </transition>

    <transition name="slide-up-in" appear>
    <svg :class="[{hide: scrolling}]" id="scroll-down" width="16px" height="114px" viewBox="0 0 16 114">
        <g id="Main-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="1.00-Home-Copy-22" transform="translate(-1358.000000, -653.000000)">
                <g id="Group-4" transform="translate(1358.000000, 654.000000)">
                    <g id="Group-12-Copy" transform="translate(0.000000, 67.000000)" fill="#33333D" fill-rule="nonzero">
                        <path d="M-14.142,25.371 C-13.9979993,26.2710045 -13.6410029,26.921998 -13.071,27.324 C-12.5009972,27.726002 -11.6520056,27.927 -10.524,27.927 C-9.95999718,27.927 -9.48900189,27.8640006 -9.111,27.738 C-8.73299811,27.6119994 -8.43000114,27.4440011 -8.202,27.234 C-7.97399886,27.023999 -7.81200048,26.7780014 -7.716,26.496 C-7.61999952,26.2139986 -7.572,25.9170016 -7.572,25.605 C-7.572,25.3529987 -7.6019997,25.1100012 -7.662,24.876 C-7.7220003,24.6419988 -7.83899913,24.429001 -8.013,24.237 C-8.18700087,24.044999 -8.42699847,23.8770007 -8.733,23.733 C-9.03900153,23.5889993 -9.4319976,23.4750004 -9.912,23.391 L-11.532,23.103 C-12.1680032,22.9949995 -12.7319975,22.8510009 -13.224,22.671 C-13.7160025,22.4909991 -14.1329983,22.2600014 -14.475,21.978 C-14.8170017,21.6959986 -15.0749991,21.3450021 -15.249,20.925 C-15.4230009,20.5049979 -15.51,19.995003 -15.51,19.395 C-15.51,18.8069971 -15.3870012,18.2910022 -15.141,17.847 C-14.8949988,17.4029978 -14.5620021,17.0310015 -14.142,16.731 C-13.7219979,16.4309985 -13.2240029,16.2090007 -12.648,16.065 C-12.0719971,15.9209993 -11.4480034,15.849 -10.776,15.849 C-9.92399574,15.849 -9.21300285,15.9419991 -8.643,16.128 C-8.07299715,16.3140009 -7.6080018,16.5629984 -7.248,16.875 C-6.8879982,17.1870016 -6.61500093,17.543998 -6.429,17.946 C-6.24299907,18.348002 -6.10200048,18.7589979 -6.006,19.179 L-7.554,19.485 C-7.65000048,19.1249982 -7.77299925,18.8040014 -7.923,18.522 C-8.07300075,18.2399986 -8.27099877,18.0060009 -8.517,17.82 C-8.76300123,17.6339991 -9.0659982,17.4930005 -9.426,17.397 C-9.7860018,17.3009995 -10.2239974,17.253 -10.74,17.253 C-11.3280029,17.253 -11.819998,17.3069995 -12.216,17.415 C-12.612002,17.5230005 -12.9299988,17.6699991 -13.17,17.856 C-13.4100012,18.0420009 -13.5809995,18.2639987 -13.683,18.522 C-13.7850005,18.7800013 -13.836,19.0529986 -13.836,19.341 C-13.836,19.6530016 -13.7970004,19.9259988 -13.719,20.16 C-13.6409996,20.3940012 -13.5090009,20.5979991 -13.323,20.772 C-13.1369991,20.9460009 -12.8940015,21.0899994 -12.594,21.204 C-12.2939985,21.3180006 -11.9220022,21.4169996 -11.478,21.501 L-9.678,21.825 C-8.34599334,22.0770013 -7.36800312,22.4939971 -6.744,23.076 C-6.11999688,23.6580029 -5.808,24.5129944 -5.808,25.641 C-5.808,26.1570026 -5.90699901,26.6399978 -6.105,27.09 C-6.30300099,27.5400023 -6.59699805,27.9329983 -6.987,28.269 C-7.37700195,28.6050017 -7.86599706,28.868999 -8.454,29.061 C-9.04200294,29.253001 -9.73199604,29.349 -10.524,29.349 C-11.2800038,29.349 -11.9669969,29.2740008 -12.585,29.124 C-13.2030031,28.9739993 -13.7399977,28.7370016 -14.196,28.413 C-14.6520023,28.0889984 -15.0179986,27.6750025 -15.294,27.171 C-15.5700014,26.6669975 -15.7379997,26.0670035 -15.798,25.371 L-14.142,25.371 Z M4.344,25.875 C4.18799922,26.9430053 3.7800033,27.7829969 3.12,28.395 C2.4599967,29.0070031 1.530006,29.313 0.33,29.313 C-0.37800354,29.313 -1.00499727,29.1990011 -1.551,28.971 C-2.09700273,28.7429989 -2.55299817,28.4160021 -2.919,27.99 C-3.28500183,27.5639979 -3.56099907,27.048003 -3.747,26.442 C-3.93300093,25.835997 -4.026,25.1550038 -4.026,24.399 C-4.026,23.6549963 -3.92400102,22.9770031 -3.72,22.365 C-3.51599898,21.7529969 -3.22200192,21.2310022 -2.838,20.799 C-2.45399808,20.3669978 -1.98600276,20.0310012 -1.434,19.791 C-0.88199724,19.5509988 -0.25800348,19.431 0.438,19.431 C1.55400558,19.431 2.41799694,19.7039973 3.03,20.25 C3.64200306,20.7960027 4.03199916,21.5489952 4.2,22.509 L2.634,22.797 C2.5739997,22.4969985 2.49300051,22.2210013 2.391,21.969 C2.28899949,21.7169987 2.1480009,21.4980009 1.968,21.312 C1.7879991,21.1259991 1.56900129,20.9820005 1.311,20.88 C1.05299871,20.7779995 0.7440018,20.727 0.384,20.727 C-0.10800246,20.727 -0.52799826,20.8199991 -0.876,21.006 C-1.22400174,21.1920009 -1.50899889,21.4499984 -1.731,21.78 C-1.95300111,22.1100017 -2.11499949,22.4969978 -2.217,22.941 C-2.31900051,23.3850022 -2.37,23.8589975 -2.37,24.363 C-2.37,24.8670025 -2.32200048,25.3409978 -2.226,25.785 C-2.12999952,26.2290022 -1.97400108,26.6159984 -1.758,26.946 C-1.54199892,27.2760017 -1.26000174,27.536999 -0.912,27.729 C-0.56399826,27.921001 -0.13800252,28.017 0.366,28.017 C1.12200378,28.017 1.68299817,27.8250019 2.049,27.441 C2.41500183,27.0569981 2.65199946,26.5350033 2.76,25.875 L4.344,25.875 Z M6.342,19.719 L7.89,19.719 L7.89,21.159 C8.23800174,20.6429974 8.64599766,20.2470014 9.114,19.971 C9.58200234,19.6949986 10.0799974,19.557 10.608,19.557 C10.9320016,19.557 11.2079989,19.5809998 11.436,19.629 L11.238,21.087 C11.1179994,21.0629999 10.9980006,21.0420001 10.878,21.024 C10.7579994,21.0059999 10.6260007,20.997 10.482,20.997 C10.1939986,20.997 9.9000015,21.0479995 9.6,21.15 C9.2999985,21.2520005 9.01800132,21.4229988 8.754,21.663 C8.48999868,21.8910011 8.28300075,22.1549985 8.133,22.455 C7.98299925,22.7550015 7.908,23.102998 7.908,23.499 L7.908,29.025 L6.342,29.025 L6.342,19.719 Z M17.106,29.313 C16.3979965,29.313 15.7680028,29.1990011 15.216,28.971 C14.6639972,28.7429989 14.1960019,28.4190021 13.812,27.999 C13.4279981,27.5789979 13.134001,27.0630031 12.93,26.451 C12.725999,25.8389969 12.624,25.1550038 12.624,24.399 C12.624,23.6429962 12.7319989,22.9590031 12.948,22.347 C13.1640011,21.7349969 13.469998,21.2130022 13.866,20.781 C14.262002,20.3489978 14.7389972,20.0160012 15.297,19.782 C15.8550028,19.5479988 16.4759966,19.431 17.16,19.431 C17.8560035,19.431 18.4799972,19.5449989 19.032,19.773 C19.5840028,20.0010011 20.054998,20.3279979 20.445,20.754 C20.8350019,21.1800021 21.131999,21.692997 21.336,22.293 C21.540001,22.893003 21.642,23.5709962 21.642,24.327 C21.642,25.0950038 21.537001,25.7849969 21.327,26.397 C21.1169989,27.0090031 20.8170019,27.5309978 20.427,27.963 C20.036998,28.3950022 19.5600028,28.7279988 18.996,28.962 C18.4319972,29.1960012 17.8020035,29.313 17.106,29.313 Z M17.124,28.017 C17.6280025,28.017 18.0599982,27.9270009 18.42,27.747 C18.7800018,27.5669991 19.0769988,27.3150016 19.311,26.991 C19.5450012,26.6669984 19.7159995,26.2800023 19.824,25.83 C19.9320005,25.3799978 19.986,24.8850027 19.986,24.345 C19.986,23.8169974 19.9320005,23.3310022 19.824,22.887 C19.7159995,22.4429978 19.5450012,22.0620016 19.311,21.744 C19.0769988,21.4259984 18.7800018,21.1770009 18.42,20.997 C18.0599982,20.8169991 17.6280025,20.727 17.124,20.727 C16.6199975,20.727 16.1910018,20.8169991 15.837,20.997 C15.4829982,21.1770009 15.1890012,21.4259984 14.955,21.744 C14.7209988,22.0620016 14.5500005,22.4429978 14.442,22.887 C14.3339995,23.3310022 14.28,23.8229973 14.28,24.363 C14.28,24.9030027 14.3339995,25.3949978 14.442,25.839 C14.5500005,26.2830022 14.7179989,26.6669984 14.946,26.991 C15.1740011,27.3150016 15.4679982,27.5669991 15.828,27.747 C16.1880018,27.9270009 16.6199975,28.017 17.124,28.017 Z M23.784,16.173 L25.35,16.173 L25.35,29.025 L23.784,29.025 L23.784,16.173 Z M27.834,16.173 L29.4,16.173 L29.4,29.025 L27.834,29.025 L27.834,16.173 Z" id="Scroll" transform="translate(6.801000, 22.599000) rotate(-90.000000) translate(-6.801000, -22.599000) "></path>
                    </g>
                    <path d="M8,51 L8,0" id="Path-8" stroke="#33333D" stroke-width="1.75" stroke-linecap="round"></path>
                    <polygon id="Path-11" stroke="#33333D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" points="1.375 45.3173828 8 52.9423828 14.625 45.3173828"></polygon>
                </g>
            </g>
        </g>
    </svg>
    </transition>

    <transition name="fade-in" enter-class="fade-in" mode="out-in" appear>
      <router-view />
    </transition>

  </div>

</template>


<script>

// @ is an alias to /src
import TsTinySquare from '@/components/TSTinySquare.vue'
import TsNav from '@/components/TSNav.vue'

export default {
  name: 'app',

  data() {
    return {
      showShapes: false,
      scrolling: false,
      firstTimeLoad: true,
      isHome: false,
      isAbout: false,
      isWorks: false
    }
  },

  components: {
    TsNav,
    TsTinySquare
  },

  watch: {
    '$route' (to, from) {
      if (to.name == "home") this.isHome = true;
      if (to.name != "home") this.isHome = false;
      if (to.name == "about") this.isAbout = true;
      if (to.name != "about") this.isAbout = false;
      if (to.name == "works") this.isWorks = true;
      if (to.name != "works") this.isWorks = false;
    }
  },

  created() {
    this.$root.$on('show-shapes', (e) => {
      this.showShapes = e;
    });
    this.$root.$on('scrolling', (e) => {
      this.scrolling = e;
    });
  },

  methods: {
    beforeEnter () {
      this.$root.$emit('scrollBeforeEnter');
    }
  },

  mounted() {
    // ensure the boolean works on first time page load
    if (this.$route.name == "home") this.isHome = true;
  }

}

</script>


<style lang="scss">

$fontPath: '~@/assets/fonts/';
$scssPath: '~@/assets/scss/';
$imagePath: '~@/assets/images/';

// saljs
@import '/assets/scss/_sal.scss';

// import grid
@import "/assets/scss/_variables";
@import "/assets/scss/_animations";
@import "/assets/scss/grid/_bootstrap-grid";
@import "/assets/scss/_fonts";

// import ui
@import "/assets/scss/ui/ts-img.scss";
@import "/assets/scss/ui/button-icon-social.scss";

// import components
@import "/assets/scss/components/ts-nav.scss";
@import "/assets/scss/components/ts-footer.scss";
@import "/assets/scss/components/ts-works-list.scss";

// import works
@import "/assets/scss/works/work.content-blocks.scss";

// import pages
@import "/assets/scss/pages/page.home.scss";
@import "/assets/scss/pages/page.about.scss";
@import "/assets/scss/pages/page.works.scss";
@import "/assets/scss/pages/page.legal.scss";
@import "/assets/scss/pages/page.all.scss";


// import dark theme
@import "/assets/scss/_dark-theme.scss";


</style>
